import * as React from 'react';
import Styled from 'styled-components';

import { SVGIcon } from '../Icon';

import { ICardProps } from './common';
import { CardStyledDiv } from './CardStyledDiv';

const StyledButton = Styled.button`
  position: absolute;
  top: 0.75em;
  right: 1em;

  svg {
    margin-left: 0.5em;
    fill: ${props => props.theme.colorSlate50};
    width: 0.75em;
    height: 0.75em;
  }
`;

export class Card extends React.PureComponent<ICardProps> {
  public static defaultProps: Partial<ICardProps> = {
    padding: '0.75em',
    disableBoxShadow: false,
  };

  public render () {
    const { onDismiss, ...rest } = this.props;

    if (onDismiss) {
      return (
        <CardStyledDiv {...rest}>
          {this.props.children}
          <StyledButton onClick={onDismiss}>
            <SVGIcon aria-hidden={false} iconTitle='close' icon='close' />
          </StyledButton>
        </CardStyledDiv>
      );
    }

    return (
      <CardStyledDiv {...rest} />
    );
  }
}
